/** Whether this page is fe-inv's own; set by standalone.ts, which such a page imports first */
let standalonePage = false

/** Marks this page as fe-inv's own, the dev harness's or Storybook's: no host signs in there */
export function markStandalonePage(): void {
  standalonePage = true
}

/**
 * Fails closed: fe-inv's own session, which refreshes from an empty token set, must never run
 * inside the PWA. Not embedded only on a page marked as fe-inv's own whose code came from the
 * page's origin, as the dev harness's does; a remote from another origin always is.
 */
export function isEmbeddedFor(
  moduleUrl: string,
  pageOrigin: string,
  standalone = standalonePage,
): boolean {
  const sameOrigin = new URL(moduleUrl).origin === pageOrigin
  return !(standalone && sameOrigin)
}

/**
 * Whether the PWA embeds fe-inv on this page, as a module federation remote sharing its token set
 * (INV-927). A function, so the mark is read when needed, never fixed by module evaluation order.
 */
export const isEmbeddedPage = (): boolean => isEmbeddedFor(import.meta.url, window.location.origin)
